const UNAVAILABLE_SELECTION = 'We can\'t calculate an online quote for this resort and loan term right now. Please try a different term or contact us for a quote.';

const MESSAGES_BY_CODE = {
  TERM_EXCEEDS_RESORT_MAXIMUM: 'That loan term isn\'t available for this resort. Please choose a shorter term.',
  DOWN_PAYMENT_EXCEEDS_PURCHASE_PRICE: 'The down payment would be more than the purchase price. Please check the number of points and the price per point.',
  RESORT_NOT_FOUND: 'Online quotes aren\'t available for this resort right now. Please contact us for a quote.',
  TITLE_COMPANY_NOT_CONFIGURED: 'Online quotes aren\'t available for this resort right now. Please contact us for a quote.',
  TITLE_COMPANY_NOT_AVAILABLE: 'Online quotes aren\'t available for this resort right now. Please contact us for a quote.',
};

/**
 * Describe a failed quote calculation for the visitor
 * @param {Error} err Error thrown by the Monera API wrapper
 * @returns {{message: string, retryable: boolean}}
 */
export const describeQuoteError = (err) => {
  if (err.status === 0) {
    return {
      message: err.timedOut
        ? 'The quote service took too long to respond. Please try again.'
        : 'We couldn\'t reach the quote service. Please check your connection and try again.',
      retryable: true,
    };
  }

  if (err.status === 400) {
    const fieldMessages = err.fields ? Object.values(err.fields).flat().filter(Boolean) : [];

    return { message: fieldMessages[0] || err.message, retryable: false };
  }

  if (err.status === 422) {
    return { message: MESSAGES_BY_CODE[err.code] || UNAVAILABLE_SELECTION, retryable: false };
  }

  if (err.status === 429) {
    return {
      message: 'You\'ve requested a lot of quotes in a short time. We\'ll update your quote again in a minute.',
      retryable: false,
    };
  }

  if (err.status === 403) {
    return { message: 'The quote calculator is temporarily unavailable. Please contact us for a quote.', retryable: false };
  }

  return { message: 'Something went wrong while calculating your quote. Please try again.', retryable: true };
};

/**
 * Describe a failure to load the calculator configuration
 * @returns {{message: string, retryable: boolean}}
 */
export const describeConfigError = () => ({
  message: 'We couldn\'t load the quote calculator. Please try again.',
  retryable: true,
});



// WEBPACK FOOTER //
// blocks/quote-calculator/app/quoteErrors.js